export enum LocalStorageKeys {
  ONBOARD = 'onboard',
  LOGIN_ATTEMPTS = 'login-attempts',
  USER = 'lnr-user',
  USERNAME = 'lnr-username',
  FIRST_NAME = 'lnr-first-name',
  PROFILE_PHOTO = 'lnr-profile-photo',
  GLOBAL_JUST_LOGGED = 'lnr-global-just-logged',
  CURRENT_REGION = 'lnr-user-current-region',
}
